import React from "react";
import Searches from "./Search";
import { useState, useEffect, useContext } from "react";
import { MyContext } from "../../context";
import TicketCard from "./TicketOverviewCards";
import TicketRightGallery from "./TicketRightGallery";
import TicketRightBar from "./TicketRightBar";
import TicketOverviewTicket from "./TicketOverviewTicket";

function TicketOverview() {
  const {
    RightLinkSelection,
    updateLinkSelection,
    updateInstallationLinkSelection,
  } = useContext(MyContext);

  const [ticketSelection, setTicketSelection] = useState();
  const [ticketName, setTicketName] = useState("");
  const [ticketFault, setTicketFault] = useState("");
  const [ticketDate, setTicketDate] = useState("");
  const [ticketDescription, setTicketDescription] = useState("");
  const [ticketInverter, setTicketInverter] = useState("");
  const [ticketBattery, setTicketBattery] = useState("");
  const [ticketLocation, setTicketLocation] = useState("");
  const [Mondayid, setMondayid] = useState("");
  const [Activeticket, setActiveticket] = useState(false)

  const [Mondayinfo, setMondayinfo] = useState("");

  useEffect(() => {
    Monday();
  }, []);

  const Monday = async () => {
    const query =
      'query {items_page_by_column_values (limit: 5, board_id: 3510729480, columns: [{column_id: "status7", column_values: ["New Ticket"]}]) {cursor items { id name column_values{id text column{title} } }}}';

      //const query =''
    try {
      await fetch("https://api.monday.com/v2", {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "eyJhbGciOiJIUzI1NiJ9.eyJ0aWQiOjI4ODQ1NzcxNSwiYWFpIjoxMSwidWlkIjo0MjMyNjYwOCwiaWFkIjoiMjAyMy0xMC0xM1QwODoxNDozNi43MjVaIiwicGVyIjoibWU6d3JpdGUiLCJhY3RpZCI6MTIyMDcwNzQsInJnbiI6InVzZTEifQ.Y6YOiQ1j6VG8KjfqZZFdtemCiyxUo9BDTg1JLGhu7Os",
          "API-version": "2023-10",
        },
        body: JSON.stringify({
          query,
        }),
      }).then(async (res) => {
        if (res.status === 200) {
          const datas = await res.json();
          const dataParse = datas.data.items_page_by_column_values.items;
          setMondayinfo(dataParse);


          setTicketName(dataParse[0].column_values[11].text);
          setTicketFault(dataParse[0].column_values[20].text);
          setTicketDate(dataParse[0].column_values[28].text);
          setTicketLocation(dataParse[0].column_values[9].text);
          setTicketInverter(dataParse[0].column_values[18].text);
          setTicketDescription(dataParse[0].column_values[10].text);
          setTicketBattery(dataParse[0].column_values[5].text);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const MondayInfoArray = Object.entries(Mondayinfo).map(([id, item]) => ({
    id,
    ...item,
  }));

  return (
    <>
      <div
        className="OverviewContainer"
        style={{ paddingLeft: "240px", paddingRight: "80px" }}
      >
        <p className="dashboard_title">Overview</p>

        <Searches />
        {/*  <ClientOverviewCode />*/}

        <div class="row">
          <div style={{ display: "flex", width: "100%" }}>
            <div style={{ paddingRight: "20px", flex: "3" }}>
              <TicketCard />

              <div
                style={{
                  paddingTop: "20px",
                  paddingLeft: "15px",
                  paddingRight: "15px",
                }}
              >
                {
                  MondayInfoArray.map((item) => (
                    <div key={item.id}>
                      <TicketOverviewTicket
                        ticketFault={ticketFault}

                        Activeticket={Activeticket}
                        Mondayid={item.id}
                        name={item.column_values[11].text}
                        inverter={item.column_values[18].text}
                        date={item.column_values[28].text}
                        type={item.column_values[5].text}
                        description={item.column_values[10].text}
                        location={item.column_values[9].text}
                        fault={item.column_values[20].text}
                        setTicketFault={setTicketFault}
                        setTicketDate={setTicketDate}
                        setTicketSelection={setTicketSelection}
                        setTicketDescription={setTicketDescription}
                        setTicketInverter={setTicketInverter}
                        setTicketBattery={setTicketBattery}
                        setTicketLocation={setTicketLocation}
                        setTicketName={setTicketName}
                        setActiveticket={setActiveticket}
                        setMondayid={setMondayid}
                      />
                    </div>
                  )) /**/
                }
              </div>
            </div>

            <div className="ticketRightSticky" style={{ flex: "1" }}>
              <TicketRightBar
                name={ticketName}
                type={ticketBattery}
                date={ticketDate}
                location={ticketLocation}
                inverter={ticketInverter}
                fault={ticketFault}
                description={ticketDescription}
              />
            {Mondayid}
              {/* <TicketRightGallery />  */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TicketOverview;
